import { render } from "./RelatedArticles.vue?vue&type=template&id=eed0b064&ts=true"
import script from "./RelatedArticles.vue?vue&type=script&lang=ts"
export * from "./RelatedArticles.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__